RivalIQ.apps.Registration.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    const INDUSTRY_ACCOUNT_GROUP_IDS = [80];

    const CompanyTypeSelect = RivalIQ.views.Select.extend({

        ui: _.extend({
            companyTypeSelect: '.company-type-btn'
        }, RivalIQ.views.Select.prototype.ui),

        name: 'companyType',

        template: '#companyTypeSelectTemplate',

        selectInitialOnRender: false,

        items: [{
            id: 'brand',
            name: 'Brand'
        }, {
            id: 'agency',
            name: 'Agency'
        }],

        isDisabled: _.constant(false),

        focus: function () {
            const me = this;
            me.ui.companyTypeSelect.focus();
        },

        serializeData: function () {
            const me = this;

            return _.extend(RivalIQ.views.Select.prototype.serializeData.call(me), {
                placeholderText: 'My company is a...'
            });
        }
    });

    const IndustriesSelect = RivalIQ.views.Select.extend({

        ui: _.extend({
            industriesSelect: '.industries-btn'
        }, RivalIQ.views.Select.prototype.ui),

        name: 'industries',

        template: '#industriesSelectTemplate',

        selectInitialOnRender: false,

        items: [],

        isDisabled: _.constant(false),

        focus: function () {
            const me = this;
            me.ui.industriesSelect.focus();
        },

        serializeData: function () {
            const me = this;

            return _.extend(RivalIQ.views.Select.prototype.serializeData.call(me), {
                items: _.sortBy(RivalIQ.settings.industryLandscapes, 'name'),
                placeholderText: 'Pick an industry'
            });
        }
    });

    views.RegistrationDetails = RivalIQ.views.LayoutView.extend({
        template: '#registrationDetailsTemplate',

        ui: {
            doneButton: '.x-done-btn',
            doneButtonWrapper: '.x-done-btn-wrapper',
            industriesContainer: '.x-industries',
            infoBubbles: '.fa-info-circle',
            competitorInputSection: '.x-competitor-input-section',
            registerError: '.register-error',
            supportBtn: '.x-contact-support',
            companyTypeContainer: '.x-company-type'
        },

        regions: {
            focusCompanyRegion: '.x-focus-company',
            competitorsRegion: '.x-competitors',
            alertsRegion: '.x-alerts'
        },

        events: {
            'click @ui.doneButton': 'onLandscapeComplete',
            'click @ui.supportBtn': 'showIntercom'
        },

        initialize: function () {
            const me = this;

            me.listenTo(App, 'company-changed', me.onCompanyChanged);
            me.listenTo(App, 'initial-focus-company-valid', me.onFocusCompanyValid);
        },

        onCompanyTypeChanged: function (companyType) {
            const me = this;

            me.model.set('isAgency', companyType === 'agency');
            me.companiesAdder.focusFirst();
            me.updateDoneButton();
        },

        onIndustriesChanged: function (industry) {
            const me = this;

            me.model.set('industry', industry);
            me.updateDoneButton();
        },

        onFocusCompanyValid: function () {
            const me = this;

            const hasCompanyTypeBeenSet = !_.isUndefined(me.model.get('isAgency'));
            if (!hasCompanyTypeBeenSet) {
                me.companyTypeSelect.focus();
            } else {
                me.companiesAdder.focusFirst();
            }
        },

        updateDoneButton: function () {
            const me = this;
            const focusCompany = me.model.get('focusCompany');
            const competitors = me.model.get('competitors').models;

            const allModels = competitors.concat([focusCompany]);

            const hasFocusCompany = Boolean(focusCompany.attributes.id);
            const hasCompetitor = Boolean(_.compact(_.map(competitors, 'attributes.id')).length);
            const isAnyCompanyLoading = _.some(_.map(allModels, 'attributes.isLoading'), function (isLoading) {
                return Boolean(isLoading);
            });

            const hasCompanyTypeBeenSet = !_.isUndefined(me.model.get('isAgency'));

            me.ui.doneButton.toggleClass('disabled', !(hasFocusCompany && hasCompetitor && !isAnyCompanyLoading && hasCompanyTypeBeenSet));

            // Explain reason for the disabled button
            if (isAnyCompanyLoading) {
                me.updateTooltipText(RivalIQ.strings.registration_warning_still_loading);
            } else if (!hasFocusCompany) {
                me.updateTooltipText(me.model.get('isAgency') ? RivalIQ.strings.registration_warning_no_focus_company_agency : RivalIQ.strings.registration_warning_no_focus_company_brand);
            } else if (!hasCompanyTypeBeenSet) {
                me.updateTooltipText(RivalIQ.strings.registration_warning_no_company_type);
            } else if (!hasCompetitor) {
                me.updateTooltipText(RivalIQ.strings.registration_warning_no_competitor);
            } else {
                me.updateTooltipText(null);
            }
        },

        updateTooltipText: function (text) {
            const me = this;

            if (!text) {
                me.ui.doneButtonWrapper.tooltip('destroy');
            } else {
                // fixTitle will force the tooltip to reload from the title attr again.
                // see https://stackoverflow.com/questions/9501921/change-twitter-bootstrap-tooltip-content-on-click/9875490#9875490
                me.ui.doneButtonWrapper.attr('title', text)
                    .tooltip('fixTitle')
                    .tooltip({
                        container: 'body',
                        trigger: 'hover'
                    });
            }
        },

        onCompanyChanged: function () {
            const me = this;
            me.updateDoneButton();
        },

        onBeforeShow: function () {
            const me = this;
            me.ui.infoBubbles.popover({
                trigger: 'hover',
                container: 'body',
                placement: 'auto'
            });
        },

        hasIndustry: function () {
            return _.includes(INDUSTRY_ACCOUNT_GROUP_IDS, RivalIQ.state.account.get('groupId'));
        },

        onRenderLoaded: function () {
            const me = this;

            const focusCompanyAdder = new App.views.CompanyAdder({
                model: me.model.get('focusCompany'),
                url: me.model.get('focusCompanyUrl'),
                isFocusCompany: true
            });
            me.focusCompanyRegion.show(focusCompanyAdder);

            me.companiesAdder = new App.views.CompaniesAdder({
                collection: me.model.get('competitors')
            });
            me.competitorsRegion.show(me.companiesAdder);

            if (me.model.get('isAgency') === null) {
                me.companyTypeSelect = new CompanyTypeSelect({
                    el: me.ui.companyTypeContainer,
                    onChange: _.bind(me.onCompanyTypeChanged, me)
                });
                me.companyTypeSelect.render();
            }

            if (me.hasIndustry()) {
                me.industriesSelect = new IndustriesSelect({
                    el: me.ui.industriesContainer,
                    onChange: _.bind(me.onIndustriesChanged, me)
                });
                me.industriesSelect.render();
            }

            if (!me.model.get('focusCompanyUrl')) {
                focusCompanyAdder.focus();
            }
        },

        onLandscapeComplete: function () {
            const me = this;

            const registration = new App.models.Registration();
            const focusCompanyName = me.model.get('focusCompany').get('name');

            const landscapeId = RivalIQ.state.landscape.id;
            const user = me.model.get('user');
            const email = user.get('email');

            user.set('account', {
                is_agency: me.model.get('isAgency'),
                lead_data: {
                    companyName: user.get('company_name'),
                    companyTitle: user.get('company_title')
                }
            });

            const userSettings = RivalIQ.apps.Registration.data.accountDefaults.defaultUserSettings(landscapeId);
            // update the client timezone so our default scheduled reports run at the right time
            userSettings.clientTimeZone = RivalIQ.utils.timezone.getClientTimezoneString();

            registration.set({
                user: user,
                cloneLandscapeId: me.model.get('industry'),
                company: me.model.get('focusCompany'),
                landscape: me.model.get('competitors'),
                landscapeName: focusCompanyName,
                reportsToSchedule: RivalIQ.apps.Registration.data.accountDefaults.reportsToSchedule(email, landscapeId),
                userSettings: userSettings
            });

            me.ui.registerError.hide();
            me.ui.doneButton.text('Loading...');
            me.ui.doneButton.toggleClass('disabled', true);
            registration.save()
                .done(function () {
                    me.pushTrackingEvent('V3RegistrationSubmit');
                    if (window.gaSignupConversionSendTo) {
                        RivalIQ.execute('tracking:push:gtag', 'conversion', {
                            send_to: window.gaSignupConversionSendTo
                        });
                    }

                    App.trigger('registration-complete');
                })
                .fail(function (xhr) {

                    if (xhr.errorName === 'AccountStatusTransitionError') {
                        // this account has already been activated, so jump into the app
                        App.trigger('registration-complete');
                        return;
                    }

                    me.ui.registerError.show();
                    me.pushTrackingEvent('V3RegistrationError');

                    me.ui.doneButton.text('Continue');
                    me.ui.doneButton.toggleClass('disabled', false);
                });
        },

        pushTrackingEvent: function (event, eventOptions) {
            RivalIQ.execute('tracking:push:auth', event, eventOptions);
        },

        showIntercom: function (e) {
            if (window.Intercom) {
                e.preventDefault();
                window.Intercom('show');
            }
        },

        templateHelpers: function () {
            const me = this;

            return {
                hasIndustry: me.hasIndustry()
            };
        }
    });

});
